module.exports = __webpack_public_path__ + "static/media/retirement-object-1-0-1.d07b0c52.svg";